import { useEffect, useState } from "react";

export function useInView(ref) {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback);

    if (ref.current) observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return isInView;
}
